import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React, { useEffect, useState } from 'react';
import { useIsMobileView } from '../../utils/responsive';
import { hasSelectableNumbers } from '../../utils/raffleType';

import { Card, CardContent } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import MeliPayLogo from "../../assets/images/svg/mercadopago.png";
import PaypalLogo from "../../assets/images/svg/paypal.png";
import WebpayLogo from "../../assets/images/svg/webpay.png";
import { MobileTickets } from './tickets/mobileTickets';
import { PurchaseDialog } from '../payment/purchaseDialog';
import FormPayment from '../payment/form/payment';
import { IWinner } from '../../store/interfaces/IWinner';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/types/rootState';
import { SoldTicketsDashboardPublic } from '../soldTickets/soldTicketsPublic';
import { MobileTicketsV2 } from './tickets/mobileTicketsV2';
import { MobileTicketsV3 } from './tickets/mobileTicketsV3';


export interface Ticket {
  id: number;
  label: string;
}

const tickets: Ticket[] = [
  { id: 0, label: 'Ingresar tickets' },
  { id: 5, label: '5 TICKET' },
  { id: 10, label: '10 TICKETS' },
  { id: 20, label: '20 TICKETS' },
];


const paymentMethods = [
  {
    value: "transbank",
    label: "Webpay",
    icon: <img
      style={{
        height: "40px",
      }}
      src={WebpayLogo}
      alt=""
      key={'transbank'}
    />,
    info: "Será redirigido a webpay para finalizar su compra",
  },
  {
    value: "paypal",
    label: "Paypal",
    icon: <img
      style={{
        height: "40px",
      }}
      src={PaypalLogo}
      alt=""
      key={'paypal'}
    />,
    info: "-",
  },
  {
    value: "mercadopago",
    label: "Red Compra",
    icon: <img
      style={{
        height: "50px",
      }}
      src={MeliPayLogo}
      alt=""
      key={'mercadopago'}
    />,
    info: "-",
  },
];


interface RaffleTicketsV2Props {
  accountId: string;
  ticketPrice: number;
  ticketPriceUSD: number;
  availablePaymentMethods: string[];
  limit: number;
  raffleType: "promo" | "raffle" | "lottery" | "talonario";
  raffleId: string;
}

const RaffleTicketsV2 = ({ ticketPrice, ticketPriceUSD,  availablePaymentMethods, limit,  raffleId, raffleType, accountId }: RaffleTicketsV2Props) => {

  
  const isLoggedIn = useSelector(({ authentication }: RootState) => authentication.isLoggedIn);
  const accountInformation = useSelector(({ account }: RootState) => account);
  const [open, setOpen] = useState(true);
  const isMobile = useIsMobileView();
  const [selectedTickets, setSelectedTickets] = useState<number[] | undefined>();
  const [ticketQuantity, setTicketQuantity] = useState<number | null>(null);
  const [minPurchase, setMinPurchase] = useState<number>(limit === 100 || raffleType === 'promo' ? 2 : 2);
  const [desktopAdditions, setDesktopAdditions] = useState<number[]>([1]);
  const [additions, setAdditions] = useState<number[]>([1]);

  useEffect(() => {
      setDesktopAdditions([2, 10, 20, 50, 100])
      setAdditions([2, 10, 20, 50, 100])
  }, []);

  useEffect(() => {
    if (accountInformation.id === 'oscar-alarcon' || accountInformation.id === 'motor-luck' || accountInformation.id === 'rifas-chente' || accountInformation.id === 'gana-con-leonardo') {
      setMinPurchase(3)
      setDesktopAdditions([3, 10, 20, 50, 100])
      setAdditions([3, 10, 20, 50, 100])
    }
    if (accountInformation.id === 'rifas-jf' || accountInformation.id === 'yilson-grau' || accountInformation.id === 'dilan-grau') {
      setMinPurchase(4)
      setDesktopAdditions([4, 10, 20, 50, 100])
      setAdditions([4, 10, 20, 50, 100])
    }
    if (accountInformation.id === 'gana-con-salazar') {
      setMinPurchase(6)
      setDesktopAdditions([6, 10, 20, 50, 100])
      setAdditions([6, 10, 20, 50, 100])
    }
    if (accountInformation.id === 'rifas-de-paquete') {
      setMinPurchase(2)
      setDesktopAdditions([2, 4, 6, 8, 10])
      setAdditions([2, 4, 6, 8, 10])
    }
    if (accountInformation.id === 'el-viejo') {
      setMinPurchase(10)
      setDesktopAdditions([10, 20, 50, 100])
      setAdditions([10, 20, 50, 100])
    }
    if (accountInformation.id === 'jgr1' || accountInformation.id === 'wild-life-rescue' || accountInformation.id === 'rifas-chente') {
      setMinPurchase(1)
      setDesktopAdditions([1, 3, 10, 20, 50])
      setAdditions([1, 3, 10, 20, 50])
    }
    
    if (accountInformation.id === 'agudojhonny') {
      setMinPurchase(1)
      setDesktopAdditions([1, 3, 10, 20, 50])
      setAdditions([1, 3, 10, 20, 50])
    }

    if (accountInformation.id === 'super-rifas-latam') {
      setMinPurchase(2)
      setDesktopAdditions([2, 5, 10, 20, 50])
      setAdditions([2, 5, 10, 20, 50])
    }


    if (raffleType === 'promo') {
      setMinPurchase(1)
      setDesktopAdditions([1])
      setAdditions([1])
    }


    if (limit === 100000) {
      setMinPurchase(20)
      setDesktopAdditions([5, 10, 20, 50, 100])
      setAdditions([5, 10, 20, 50, 100])
    }
  }, []);


  const handleChangeQuantity = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    let parsedValue: number | null = parseInt(value);
    const limitPurchase = raffleType === 'promo' ? 2 : limit === 10000 ? 500 : limit * 0.25;

    if (isNaN(parsedValue) || parsedValue < 0) {
      parsedValue = null;
    } else if (parsedValue > limitPurchase) {
      enqueueSnackbar(`El limite de compra para esta rifa es ${limitPurchase}!`, {
        variant: "error",
        anchorOrigin: {
          horizontal: "left",
          vertical: "top"
        },
      })
      parsedValue = limitPurchase;
    } else if (parsedValue < minPurchase) {
      enqueueSnackbar(`El mínimo de compra para la rifa es ${minPurchase}!`, {
        variant: "warning",
        anchorOrigin: {
          horizontal: "left",
          vertical: "top"
        },
      })
    }
    setTicketQuantity(parsedValue);
  };

  const sumTicketQuantity = (event: number) =>  {
    const limitPurchase = raffleType === 'promo' ? 2 : limit === 10000 ? 500 : limit * 0.25;
    if (ticketQuantity) {
      let parsedValue: number | null = ticketQuantity + event;
      if (isNaN(parsedValue) || parsedValue < 0) {
        parsedValue = null;
      } else if (parsedValue > limitPurchase) {
        enqueueSnackbar(`El limite de compra es ${limitPurchase}!`, {
          variant: "error",
          anchorOrigin: {
            horizontal: "left",
            vertical: "top"
          },
        })
        return
      }

      setTicketQuantity(ticketQuantity + event);
    } else {
      setTicketQuantity(event);
    }
  }

  const [selectedPaymentMethod, setSelectedPaymentMethod] =
  React.useState<string | null>(null);
const [purchaserData, setPurchaserData] = React.useState<IWinner>({
  name: "",
  email: "",
  phone: "",
});

const handlePaymentMethodSelect = (method: string) => {
  setOpen(false)
  setSelectedPaymentMethod((prevMethod) =>
    prevMethod === method ? null : method
  );
};

const setTicketQuantityHandler = (ticketQuantity: number) => {
  setTicketQuantity(ticketQuantity);
}



  return (
    <Box paddingX={4}>
      {ticketQuantity && isLoggedIn && selectedPaymentMethod && <PurchaseDialog ticketQuantity={ticketQuantity} raffleId={raffleId} isMobile={isMobile} open={open} setOpen={setOpen} totalAmount={ticketQuantity * ticketPrice} totalAmountUSD={ticketQuantity * ticketPriceUSD}  availablePaymentMethods={availablePaymentMethods} />}
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          { raffleType === 'raffle' ? <Grid container spacing={2}>
            {!isMobile ? (
              <>
              <Card sx={{
                width: '100%',
              }}>
                <CardContent>
                  <Box>
                    <MobileTicketsV3
                    additions={desktopAdditions}
                    handleChangeQuantity={handleChangeQuantity}
                    sumTicketQuantity={sumTicketQuantity}
                    ticketQuantity={ticketQuantity}
                    />
                  </Box>
                </CardContent>
              </Card>
              </>
            ) : <MobileTicketsV3
                additions={desktopAdditions}
                handleChangeQuantity={handleChangeQuantity}
                sumTicketQuantity={sumTicketQuantity}
                ticketQuantity={ticketQuantity}
                />
            }
          </Grid> : hasSelectableNumbers(raffleType) ? <SoldTicketsDashboardPublic 
          limit={limit} 
          setTicketQuantity={setTicketQuantityHandler}
          setSelectedTickets={setSelectedTickets}
          ticketQuantity={ticketQuantity}
          raffleId={raffleId}
          ></SoldTicketsDashboardPublic> : <Card sx={{
            width: '100%',
          }}>
            <CardContent>
              <Box>
                <MobileTickets
                additions={desktopAdditions}
                handleChangeQuantity={handleChangeQuantity}
                sumTicketQuantity={sumTicketQuantity}
                ticketQuantity={ticketQuantity}
                />
              </Box>
            </CardContent>
          </Card>}
        </Grid>
        <Grid item xs={12} md={12}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexDirection={"column"}
            paddingY={2}
            paddingTop={isMobile ? 1 : 2}
            width="100%"
          >

            <FormPayment 
                minPurchase={minPurchase}
                selectedTickets={selectedTickets}
                availablePaymentMethods={availablePaymentMethods}
                handlePaymentMethodSelect={handlePaymentMethodSelect}
                purchaserData={purchaserData}
                raffleId={raffleId}
                selectedPaymentMethod={'transfer'}
                setOpen={setOpen}
                setPurchaserData={setPurchaserData}
                ticketQuantity={ticketQuantity || 0} 
                totalAmount={(ticketQuantity || 0) * ticketPrice} 
                totalAmountUSD={(ticketQuantity || 0) * ticketPriceUSD}
                />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default RaffleTicketsV2;
